import { Injectable, Inject } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { PointerState } from "../canvas/input-manager";
import { GAME_ENGINE } from "../service-tokens";
var Messenger = (function () {
    function Messenger(worker_) {
        var _this = this;
        this.worker_ = worker_;
        this.inputs$ = new Subject();
        this.model_changes_ = new Subject();
        this.handleMessages = function (event) {
            var array = new Float32Array(event.data.buffer);
            _this.model_changes_.next(array);
        };
        this.worker_.onmessage = this.handleMessages;
        this.inputs$.subscribe(function (inputs) {
            _this.worker_.postMessage(inputs);
        });
    }
    ;
    Messenger.prototype.getChanges = function () {
        return this.model_changes_.asObservable();
    };
    ;
    Messenger.prototype.sendInputs = function (inputs) {
        this.inputs$.next(inputs);
    };
    ;
    Messenger.prototype.dispose = function () {
        removeEventListener("message", this.handleMessages);
        this.model_changes_.complete();
        this.inputs$.complete();
    };
    ;
    Messenger.decorators = [
        { type: Injectable },
    ];
    Messenger.ctorParameters = function () { return [
        { type: Worker, decorators: [{ type: Inject, args: [GAME_ENGINE,] },] },
    ]; };
    return Messenger;
}());
export { Messenger };
;
//# sourceMappingURL=messenger.js.map